/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function faqs() {
  $('.toggles__toggle, .faq__answer').hide();
  $('.toggleWrap, .faq').on('click tap', function () {
    $(this).toggleClass('active');
    $(this).find('.toggles__toggle, .faq__answer').slideToggle();
  });
}
